module.exports = __webpack_public_path__ + "static/site_bg-32d4f2ea4adeb266d64ac74bb20af717.jpg";